import React from 'react';
import { AlertListPage } from '../alerts/ListPage/AlertListPage';
import { Route } from 'react-router-dom';

export const routes = [<Route key="0" path="/alerts" component={AlertListPage} />];

export const navigation = [{ name: 'alerts', link: '/alerts', icon: 'Alert' }];
